<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator='{ on }'>
        <v-btn
          :color="profile.is_active ? 'success' : 'error'"
          v-on='on'
          @click='confirmToggle'
          depressed
        >
          <v-icon v-if='profile.is_active'>mdi-check-circle</v-icon>
          <v-icon v-else>mdi-archive</v-icon>
          <span v-if='profile.is_active'>Active</span>
          <span v-else>Inactive</span>
        </v-btn>
      </template>
      <span v-if='profile.is_active'>Click to deactivate</span>
      <span v-else>Click to activate</span>
    </v-tooltip>
    <wc-confirm
      :showDialog='showConfirm'
      @cancel='showConfirm = false'
      @confirm='toggleActivation'
    >
      Are you sure you want to 
      <span v-if='profile.is_active'>deactivate</span>
      <span v-else>re-activate</span>
       this account?
    </wc-confirm>
  </div>
</template>

<script>
import _ from 'lodash'
import staffingAPI from '../../api/staffing'

export default {
  name: 'deactivate',
  props: {
    profile: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    profileCopy: {},
    user: {
      id: '',
      is_active: false
    },
    showConfirm: false
  }),
  methods: {
    confirmToggle () {
      this.showConfirm = true
    },
    async toggleActivation () {
      this.isLoading = true
      this.user.id = this.profile.user
      this.user.is_active = !this.profile.is_active
      this.profileCopy = _.cloneDeep(this.profile)
      this.profileCopy.is_active = this.user.is_active
      await staffingAPI.updateUser(this.user)
      this.$emit('update', this.profileCopy)
      this.showConfirm = false
      this.isLoading = false
    }
  }
}
</script>
